import { createRoot } from '@wordpress/element';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';

import Store from './store/Store';
import App from './App';
import messages_en from '../languages/en.json'; // 👈 your extracted messages

import './scss/app.scss';

const rootElement = document.getElementById('wooArchiveRoot');
const root = createRoot(rootElement);

root.render(
    <Provider store={Store}>
        <IntlProvider locale="bn-BD" messages={Object.fromEntries(
            Object.entries(messages_en).map(([id, obj]) => [id, obj.defaultMessage])
        )}>
            <App />
        </IntlProvider>
    </Provider>
);
